module.exports = __webpack_public_path__ + "img/unterricht-dashboard-cover-background.74a2acda.png";